
import { defineComponent, reactive, ref, Ref } from 'vue'

import { useOnOutsidePress } from 'vue-composable'

export default defineComponent({
    name: 'new-button',
    props: {
        type: {
            type: String,
            default: 'button',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const state = reactive({
            is_popup_opened: false,
        })

        const elementref: Ref<HTMLElement | null> = ref(null)

        const closePopup = () => {
            state.is_popup_opened = false
        }

        const emitClick = (event: MouseEvent) => {
            if (props.loading || props.disabled) return

            state.is_popup_opened = true
            emit('click', event)
        }

        useOnOutsidePress(elementref, closePopup)

        return { state, elementref, emitClick }
    },
})
